import { greenCheck } from "~/assets/assets";
import { HubbleRoute, PageAlignment, pushPage } from "~/shared_states/modal";
import { HubbleBranding } from "~/widgets/branding";
import { ButtonRegular } from "~/widgets/button";
import Home from "~/screens/home/home";

export function SuccessfulBankTransfer(props: { amount: number }) {
  return (
    <div class="relative flex h-full w-full flex-col items-start justify-start bg-baseTertiaryLight">
      <div class="absolute left-1/2 top-1/2 flex -translate-x-1/2 -translate-y-3/4 flex-col items-center justify-center">
        <img src={greenCheck} class="h-[72px] w-[72px]" alt="success" />
        <p class="mt-3 text-h1 font-bold text-successDark">₹{props.amount}</p>
        <p class="mt-1 text-center text-h5 text-textDark">
          Transferred to <br /> your bank account
        </p>
        <p class="mt-1 text-nowrap text-medium text-textNormal">
          via UPI ID: 731893838013@ybl
        </p>
      </div>
      <div class="absolute bottom-4 left-4 right-4 flex flex-col gap-4">
        <ButtonRegular
          isEnabled={true}
          onClick={() => {
            pushPage(
              () => <Home />,
              {
                isModal: false,
                alignment: PageAlignment.bottom,
                offset: { top: 20, right: 20 },
              },
              HubbleRoute.HOME
            );
          }}
          class="mt-5 w-full"
        >
          Got it
        </ButtonRegular>
        <HubbleBranding class="border-none" />
      </div>
    </div>
  );
}
